export default __webpack_public_path__ + "static/media/SomethingExciting.71325791.svg";